
import { defineComponent, computed } from 'vue'
import { FormDataStructure } from '@/contracts/forms/FieldContracts'
import { NuxeoUpdateUserResponse } from '@/contracts/api/ResponseContracts'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Heading from '@/components/Heading.vue'
import Form from '@/components/Form.vue'
import { axiosPostAccountUpdate } from '@/composables/api'

export default defineComponent(
{
    name: 'AccountUpdateEmail',
    components:
    {
        Heading,
        Form
    },
    setup()
    {
        // Load router:
        const router = useRouter()
        // Load vuex:
        const store = useStore()

        // Computed state params:
        const authenticatedUser = computed(() =>
        {
            return store.getters['auth/getUser']
        })

        // Set email fields:
        const fields =
        {
            email:
            {
                name: 'email',
                type: 'Input',
                label: 'New email address',
                inputType: 'email',
                autocomplete: 'email',
                width: 'govuk-input--width-20',
                rules:
                {
                    required:
                    {
                        config: true
                    },
                    email:
                    {
                        config: true
                    },
                    max:
                    {
                        config: 255
                    }
                }
            },
            emailconfirm:
            {
                name: 'emailconfirm',
                type: 'Input',
                label: 'Confirm new email address',
                hint: 'Please confirm your new email address',
                inputType: 'email',
                width: 'govuk-input--width-20',
                rules:
                {
                    required:
                    {
                        config: true
                    },
                    confirm:
                    {
                        config: 'email'
                    }
                }
            }
        }
        // Set email buttons:
        const buttons =
        {
            submit:
            {
                name: 'submit',
                type: 'Submit',
                text: 'Change email address'
            }
        }
        // Handle email submission. The target user is the signed-in caller,
        // pinned server-side from the Bearer token (never sent from here).
        const saveFormData = (formData: FormDataStructure) =>
        {
            axiosPostAccountUpdate(
            {
                email: formData.email.toLowerCase()
            },
            function(response: NuxeoUpdateUserResponse)
            {
                store.commit('auth/setAuthenticatedUser',
                {
                    id: response.id,
                    email: response.properties.email.toLowerCase()
                })
                // Token persists across the email change automatically — it
                // lives on the auth slice (not the user slice) and Nuxeo
                // does not invalidate the session when email is updated.
                store.commit('confirmations/setConfirmationData',
                {
                    title: 'Email address changed',
                    body: 'Your email address has been updated'
                })
                router.push({ hash: '#confirmation-summary-container' })
            })
        }

        // Return data:
        return {
            authenticatedUser,
            fields,
            buttons,
            saveFormData
        }
    }
})
